module.exports = require("lodash/forOwn");


//////////////////
// WEBPACK FOOTER
// external "lodash/forOwn"
// module id = 591
// module chunks = 0